<template>
    <div style="border: 1px solid green;" class="pa-4">
       <v-row>
           <v-col cols="4">
                <div>
                    <v-icon>mdi-pencil-box-outline</v-icon> {{ $t('reservation_confirm_group') }}
                </div>
            </v-col>
            <v-col cols="8">
                : {{ group_name }}
            </v-col>
       </v-row>
       <v-row>
           <v-col cols="4">
                <div>
                    <v-icon>mdi-calendar</v-icon> {{ $t('reservation_confirm_date') }}
                </div>
            </v-col>
            <v-col cols="8">
                : {{ date }}
            </v-col>
       </v-row>
       <v-row>
           <v-col cols="4">
                <div>
                    <v-icon>mdi-clock</v-icon> {{ $t('reservation_confirm_time') }}
                </div>
            </v-col>
            <v-col cols="8">
                : {{ time }}
            </v-col>
       </v-row>
       <v-row v-if="extranote.length>0">
           <v-col cols="4">
                <div>
                    <v-icon>mdi-text-box-plus-outline</v-icon> ข้อมูลเพิ่มเติม
                </div>
            </v-col>
            <v-col cols="8" >
                <div v-for="(item, index) in extranote" :key="index">
                    <li>{{item.extranote_value}}</li>
                </div>
            </v-col>
       </v-row>
    </div>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'

export default {
  data () {
    return {
      group_name : ""
      ,date : ""
      ,time : ""
      ,extranote : []
    }
  },
  mounted : function () {

    this.date = AppointmentSelection.getDate()
    var time = AppointmentSelection.getTime()
    var timestartstr = '0000' + time[0];
    timestartstr = timestartstr.substring(timestartstr.length-4,timestartstr.length)
    var timeendstr = '0000' + time[1];
    timeendstr = timeendstr.substring(timeendstr.length-4,timeendstr.length)
    this.time = timestartstr.substring(0,2) + ':' + timestartstr.substring(2,4) + " - " + timeendstr.substring(0,2) + ':' + timeendstr.substring(2,4);

    this.extranote = JSON.parse(AppointmentSelection.getExtranoteValue())

    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.appointment.get_groupshortdetail,{group_id:AppointmentSelection.getGroupId(),lang:'th'})
    .then(response => {
        this.group_name = response.data.group_name
        this.$store.commit('finishLoading',que)
    })
  },
}
</script>